import { render, staticRenderFns } from "./FreeCoins.vue?vue&type=template&id=8a2b88ca&scoped=true&"
import script from "./FreeCoins.vue?vue&type=script&lang=ts&"
export * from "./FreeCoins.vue?vue&type=script&lang=ts&"
import style0 from "./FreeCoins.scss?vue&type=style&index=0&id=8a2b88ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2b88ca",
  null
  
)

export default component.exports